import api from './api';

const unPatchableFields = [
  'isVerified',
  'verifyToken',
  'verifyShortToken',
  'verifyExpires',
  'verifyChanges',
  'resetToken',
  'resetShortToken',
  'resetExpires',
  'resetAttempts',
];

const clean = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === '' ||
      unPatchableFields.includes(propName)
    ) {
      delete obj[propName];
    }
  }
  return obj;
};

const getUserMe = (id) => api.get('/users/' + id);

const getUsers = (payloads) =>
  api.get('/users', {
    params: clean(payloads),
  });

const createUser = (username, email, password) =>
  api.post('/users', { username, email, password });

const createUserData = (user) => api.post('/users', clean(user));

const editUser = (user) => api.patch('/users/' + user._id, clean(user));

const deleteUser = (id) => api.delete('/users/' + id);

export {
  getUsers,
  createUser,
  createUserData,
  getUserMe,
  editUser,
  deleteUser,
};
